import React, { useEffect, useState } from "react";
import * as S from "./styles";
import {
  deleteTag,
  loadTags,
  toggleTagVisibility,
  updateTagName,
} from "modules/app/utils/http/tags";
import { useMainState } from "modules/app/contexts";
import { API } from "shared/services";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

function TagsManager() {
  const { t } = useTranslation();
  const [allTags, setAllTags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useMainState();
  const history = useHistory();

  const columns = [
    {
      field: "name",
      type: "string",
      headerName: t("TagsManager:columnsHeader.name"),
      width: 240,
    },
    {
      field: "receive_lead",
      type: "actions",
      headerName: t("TagsManager:columnsHeader.show"),
      width: 200,
      renderCell: renderSwitch,
    },
    {
      field: "origin",
      type: "string",
      headerName: t("TagsManager:columnsHeader.origin"),
      width: 340,
      valueFormatter: (params) =>
        `${t("TagsManager:createdBy")} ${params.row?.user?.name}`,
    },
    {
      field: "edit",
      type: "actions",
      headerName: t("TagsManager:columnsHeader.edit"),
      width: 150,
      renderCell: renderEditButton,
    },

    {
      field: "delete",
      type: "actions",
      headerName: t("TagsManager:columnsHeader.delete"),
      width: 220,
      renderCell: renderDeleteButton,
    },
  ];

  function renderSwitch(params) {
    const { row, id } = params;

    async function handleClick(row, id) {
      const { visible } = row;

      try {
        setAllTags(
          allTags.map((tag) => {
            if (tag.id === row.id) {
              return { ...tag, visible: !row.visible };
            }

            return { ...tag };
          })
        );
        await toggleTagVisibility(visible, id);
      } catch (err) {
        console.log(err);
      }
    }

    return (
      <S.ShowTagSwitch
        checked={row.visible}
        onClick={() => handleClick(row, id)}
        color="primary"
      />
    );
  }

  function renderDeleteButton(params) {
    return (
      <S.Button onClick={() => handleDeleteTag(params.id)}>
        <S.DeleteIcon />
      </S.Button>
    );
  }

  function renderEditButton(params) {
    const { row } = params;

    return (
      <Link
        to={{
          pathname: `/app/tags/${row.id}`,
          state: { currentTagName: row.name },
        }}
      >
        <S.Button>
          <S.EditIcon />
        </S.Button>
      </Link>
    );
  }

  async function handleDeleteTag(id) {
    const newArrayOfTags = allTags.filter((tag) => tag.id !== id);

    try {
      await deleteTag(id);
      setAllTags(newArrayOfTags);
      toast.success(t("TagsManager:deleteTagSuccess"));
    } catch (error) {
      toast.error(t("TagsManager:deleteTagError"));
    }
  }

  async function fetchTags() {
    setIsLoading(true);

    try {
      const data = await loadTags();
      setAllTags(data);
    } catch (err) {
      toast.error(t("TagsManager:fetchingError"));
    }

    setIsLoading(false);
  }

  useEffect(() => {
    if (user?.role == "seller") {
      history.push("/app");
      toast.error(t("TagsManager:entryForbidden"));
    }
  }, [user]);

  useEffect(() => {
    fetchTags();
  }, []);

  return (
    <S.Container>
      <S.TagsManagerTitle> {t("TagsManager:title")}</S.TagsManagerTitle>

      {isLoading ? (
        <S.LoadingContainer>
          <S.Loading />
        </S.LoadingContainer>
      ) : (
        <S.TagsManagerTable
          disableColumnMenu
          disableSelectionOnClick
          columns={columns}
          rows={allTags || []}
          rowCount={allTags?.length || 0}
          isCellEditable={false}
          pageSize={10}
        />
      )}

      <S.CreateTagContainer>
        <S.CreateTagButton
          color="primary"
          aria-label="add"
          variant="extended"
          onClick={() => history.push("/app/tags/new")}
        >
          <S.CreateTagIcon />
          {t("TagsManager:createNewTagButton")}
        </S.CreateTagButton>
      </S.CreateTagContainer>
    </S.Container>
  );
}

export default TagsManager;
